export default __webpack_public_path__ + "static/media/sets.0bffc12b.svg";